app.service("Session", [
	"localStorageService",
	"$cookies",
	function (localStorageService, $cookies) {
		// Each tab signs in on its own, so tabs in one browser can be signed in as different users. Cookies are
		// shared by every tab, so the server keeps each sign-in's refresh cookies under an id the tab names in the
		// X-CATTRAX-SIGN-IN header, and the tab keeps that id in sessionStorage, which is its own. What is stored:
		//   nothing    - a new tab. It continues the browser's latest sign-in, and is told that one's id.
		//   SIGNED_OUT - this tab signed out, or chose to sign in as someone else, so it waits at the login page
		//                rather than continuing another tab's sign-in.
		//   an id      - this tab's sign-in.
		const SIGN_IN_KEY = "cattrax.signIn";
		const SIGNED_OUT = "signed-out";
		const SIGN_IN_ID = /^[0-9a-f]{16,64}$/;

		function readSignIn() {
			try {
				return window.sessionStorage.getItem(SIGN_IN_KEY);
			} catch (e) {
				return null;
			}
		}

		function writeSignIn(value) {
			try {
				window.sessionStorage.setItem(SIGN_IN_KEY, value);
			} catch (e) {
				// Without sessionStorage the tab uses the browser's one shared sign-in, as before sign-ins had ids.
			}
		}

		function newSignInId() {
			const bytes = new Uint8Array(16);
			window.crypto.getRandomValues(bytes);
			return Array.prototype.map.call(bytes, (b) => ("0" + b.toString(16)).slice(-2)).join("");
		}

		// The DICOM viewer reads the API token from the cattrax_bearer_token cookie, which every tab shares. The
		// tab in front writes it, and writes it again when it comes back to the front, so the viewer always uses
		// the user of the tab it is open in - not another tab's, refreshed in the background.
		function shareTokenWithViewer() {
			if (service.token && document.visibilityState !== "hidden") {
				$cookies.put("cattrax_bearer_token", service.token);
			}
		}

		var service = {
			user: {},
			practice: null,
			// What the user may do at the current practice. Set with the practice - see hasPermission().
			permissions: [],
			practiceOptions: [],
			timestamp: null,
			xeroLogin: null,
			token: null,
			userId: null,
			refresh_token: null,
			// backgroundTask: null,

			create: function (token, expires_in, userId, refresh_token) {
				service.token = token;
				service.userId = userId;
				service.timestamp = Date.now() + expires_in * 1000;
				service.refresh_token = refresh_token;
				shareTokenWithViewer();
				// var obj = {
				// 	token: token,
				// 	userId: userId,
				// 	timestamp: service.timestamp,
				// 	refresh_token
				// };
				// localStorageService.set("userObj", obj);
				/** 
				service.backgroundTask = setInterval(() => {
					
					if (Date.now() + 5 * 60 * 1000 > service.timestamp) {
						$rootScope.sessionExpireModal && $rootScope.sessionExpireModal.hide();
						$rootScope.relogin = function () {
							$rootScope.sessionExpireModal && $rootScope.sessionExpireModal.hide();
							service.destroy();
							$state.go('login');
						}
						const minute = (service.timestamp - Date.now())/1000/60
						$rootScope.sessionExpireModal = $modal({
							scope: $rootScope,
							templateUrl: "app/src/views/templates/modal.session-expire.tpl.html",
							show: true,
							keyboard: false,
							backdrop: "static",
							title: `Your session is about to expire in ${Math.floor(minute)} minute`,
						});
					}
				}, 60 * 1000);
				*/
			},

			destroy: function () {
			    // $http({
				// 	method: 'POST',
				// 	url: ENV.API + '/api/security/logout',
				// 	headers: {
				// 		'Authorization': 'Bearer ' + service.token,
				// 	}
				// })
				// Only this tab's token is taken from the viewer's cookie; another tab may have written its own.
				if (service.token && $cookies.get("cattrax_bearer_token") === service.token) {
					$cookies.remove("cattrax_bearer_token");
				}
				service.userId = null;
				service.practice = null;
				service.permissions = [];
				service.practiceOptions = [];
				service.token = null;
				service.refresh_token = null;
				service.xeroLogin = null;
				localStorageService.clearAll();
				/** 
				if(service.backgroundTask){
					clearInterval(service.backgroundTask);
				}
				*/
			},

			// The header naming this tab's sign-in, for the requests that sign in, refresh and sign out. Added to
			// `headers` when the tab has a sign-in; a new tab sends none, and the server picks the latest.
			SIGN_IN_HEADER: "X-CATTRAX-SIGN-IN",

			signInHeaders: function (headers) {
				const signInId = readSignIn();
				if (signInId && SIGN_IN_ID.test(signInId)) {
					headers[service.SIGN_IN_HEADER] = signInId;
				}
				return headers;
			},

			// Signing in always starts a sign-in of this tab's own, leaving any other tab's alone.
			startSignIn: function () {
				writeSignIn(newSignInId());
			},

			// A refresh says which sign-in it used - for a new tab, the browser's latest - and the tab keeps it.
			continueSignIn: function (resp) {
				const signInId = resp && resp.headers && resp.headers(service.SIGN_IN_HEADER);
				if (signInId && SIGN_IN_ID.test(signInId)) {
					writeSignIn(signInId);
				}
			},

			endSignIn: function () {
				writeSignIn(SIGNED_OUT);
			},

			isSignedOutHere: function () {
				return readSignIn() === SIGNED_OUT;
			},

			setPractice: function (practice) {
				// Billing authorisation is held per user *and* practice, so an answer cached against one
				// practice says nothing about the next. Only a real change clears it - refreshSessionPractice()
				// re-sets the practice already selected, and that must not throw away a good answer.
				const previousPracticeId = service.practice && service.practice.id;
				const nextPracticeId = practice && practice.id;
				if (previousPracticeId !== nextPracticeId) {
					service.xeroLogin = null;
				}

				service.practice = practice;
				service.permissions = (practice && practice.permissions) || [];
			},

			setCurrentUser: function (user) {
				if (!user.features) {
					user.features = {};
				}
				if (user.features && !user.features.favoritePatientsFeature) {
					user.features.favoritePatientsFeature = [];
				}
				service.user = user;
			},

			setPracticeOptions: function (practiceList) {
				practiceList.sort((a, b) => {
					const nameA = a.name;
					const nameB = b.name;
					if (nameA < nameB) {
					  return -1;
					}
					if (nameA > nameB) {
					  return 1;
					}
					return 0;
				  });
				service.practiceOptions = practiceList;
			},

			setXeroLoginState: function (state) {
				service.xeroLogin = state;
			},

			// Checks the user's whole roles array, not roles[0]. A user can hold several roles, so the
			// roles[0] idiom used in older components silently misses the others.
			hasAnyRole: function (roleList) {
				const roles = (service.user && service.user.roles) || [];
				return roles.some(function (role) {
					return roleList.indexOf(role) !== -1;
				});
			},

			// Whether the user may do something at the practice they are working in, e.g.
			// hasPermission("CLINICAL_RECORD_VIEW"). The list comes from the server with each practice
			// (GET /api/users/{id}/practices) and already leaves out features the practice doesn't pay
			// for. The server checks again on every request - this only decides what the screen offers.
			// Use roles only for what a user's profession is (e.g. which referral types they see).
			hasPermission: function (permission) {
				return service.permissions.indexOf(permission) !== -1;
			},

			// The same check for a practice from practiceOptions that may not be the one the user is
			// working in, e.g. a practice's section of the Settings dialog.
			hasPermissionAt: function (practice, permission) {
				return !!practice && (practice.permissions || []).indexOf(permission) !== -1;
			},

			// Whether the user may open a surgery workup here and fill it in. Submitting it also needs
			// SURGERY_WORKUP_CREATE, which pre-op checks on its SUBMIT button. The server leaves both out
			// for an Optometrist at an optometry practice unless another of their roles gives them.
			canStartWorkup: function () {
				return service.hasPermission("SURGERY_WORKUP_UPDATE");
			},

			// Whether the note form offers this type. The screen keeps Practice Admins to admin notes and nurses
			// to nurse and admin notes, though the server lets them write more; the type's permission is needed too.
			canWriteNoteType: function (type) {
				const roles = (service.user && service.user.roles) || [];
				const offered = roles.some(function (role) {
					if (role === "PRACTICE_ADMIN") {
						return type === "ADMIN_NOTE";
					}
					if (role === "REGISTERED_NURSE" || role === "CLINICAL_NURSE_SPECIALIST") {
						return type === "NURSE_NOTE" || type === "ADMIN_NOTE";
					}
					return true;
				});
				const permission = { NURSE_NOTE: "CLINICAL_NURSE_NOTE_WRITE", ADMIN_NOTE: "CLINICAL_ADMIN_NOTE_WRITE" }[type]
					|| "CLINICAL_PROGRESS_NOTE_WRITE";
				return offered && service.hasPermission(permission);
			},

			// The note type a new progress note starts as: a progress note, else a nurse note, else an admin
			// note, whichever the user may write first. Null if they may write none.
			defaultProgressNoteType: function () {
				return ["PROGRESS_NOTE", "NURSE_NOTE", "ADMIN_NOTE"].find(service.canWriteNoteType) || null;
			},

			// A doctor who may countersign a nurse's standing order.
			isDoctor: function () {
				return service.hasPermission("CLINICAL_PROGRESS_NOTE_SIGN_OFF");
			},

			// A clinician who may save medications and generate prescriptions.
			canSubmitMedication: function () {
				return service.hasPermission("CLINICAL_MEDICATION_PRESCRIBE");
			},

			// Whether the user has a professional registration number. Patient certificates print it,
			// and the backend fails the whole request without one. The backend is the authoritative
			// gate - this only decides what is offered.
			hasProfessionalRegistration: function () {
				const registration = service.user && service.user.registration;
				return !!(registration && registration.number && `${registration.number}`.trim());
			},

			// Whether this practice has the clinic calendar. Pass a practice from
			// practiceOptions to ask about one other than the one you are working in today.
			hasCalendar: function (practice) {
				const features = ((practice || service.practice) || {}).practiceFeatures || {};
				return !!features.calendarFeature;
			},

			// Reminders are written per appointment type, and appointment types only exist
			// with the calendar. AppointmentReminderController checks the calendar feature
			// before every reminder call and rejects the request without it, so a reminder
			// channel on its own does not give the practice a reminder screen that works.
			// The backend check is the authoritative gate - this only decides what is offered.
			hasAppointmentReminders: function (practice) {
				const features = ((practice || service.practice) || {}).practiceFeatures || {};
				return (
					!!features.calendarFeature &&
					!!(features.appointmentEmailReminderFeature || features.appointmentSMSReminderFeature)
				);
			},

			// Whether this practice takes patient payments on a Tyro EFTPOS terminal. Off, the claim
			// screens offer only recording a payment taken another way.
			hasTyroTerminal: function (practice) {
				const features = ((practice || service.practice) || {}).practiceFeatures || {};
				return !!features.tyroTerminalFeature;
			}
		};

		document.addEventListener("visibilitychange", shareTokenWithViewer);
		window.addEventListener("focus", shareTokenWithViewer);

		return service;
	},
]);